module.exports = __webpack_public_path__ + "headset-8d13dc33307fdd035964.svg";